import React from 'react';
import logo from "../../assets/images/logo.png";
import twitter from "../../assets/images/twitter.svg";
import discord from "../../assets/images/discord.svg";
import medium from "../../assets/images/medium.svg";
import logo_icon_only from "../../assets/images/logo_icon_only.png";

const Footer = () => {
    return (
        <footer className="flex justify-between pt-10 place-items-center px-5 lg:px-20 py-6 bg-[#171717]">
            <img className="hidden lg:block" src={logo} width={280} alt="logo"></img>
            <img className="block lg:hidden" src={logo_icon_only} width={45} alt="logo"></img>
            <div className="flex gap-5">
                <a className="hvr-grow" href="#" target="_blank">
                    <div className="flex w-[37px] h-[37px] bg-[rgba(255,_255,_255,_0.15)] rounded-full place-items-center justify-center">
                        <img src={twitter} width={20} alt={"twitter"} />
                    </div>
                </a>
                <a className="hvr-grow" href="#" target="_blank">
                    <div className="flex w-[37px] h-[37px] bg-[rgba(255,_255,_255,_0.15)] rounded-full place-items-center justify-center">
                        <img src={discord} width={20} alt={"twitter"} />
                    </div>
                </a>
                <a className="hvr-grow" href="#" target="_blank">
                    <div className="flex w-[37px] h-[37px] bg-[rgba(255,_255,_255,_0.15)] rounded-full place-items-center justify-center">
                        <img src={medium} width={20} alt={"twitter"} />
                    </div>
                </a>
            </div>
        </footer>
    );
};

export default Footer;